module.exports = __webpack_public_path__ + "df1d8ae32ffbd4c3d0a8c0063bc6564e.pdf";